module.exports = __webpack_public_path__ + "img/map_Z3.7.B.02.05647402.svg";